import React from 'react'
import { Navigation, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Link } from 'react-router-dom';
import Events from '../../api/event'

const EventsSection = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section className={`events-section section-padding ${props.eClass}`}>
            <div className="container">
                <div className="row">
                    <div className="col col-lg-5 col-12">
                        <div className="section-title">
                            <span>#Events</span>
                            <h2><span>Fundraising </span>events,Please join.</h2>
                        </div>
                        <div className="about-details">
                            <p>Magazine and housed in a nice, gilded frame. It showed a lady fitted out with a fur hat and fur boa who sat upright, raising a heavy fur muff that covered the whole of her lower arm towards the viewer. Gregor then turned to look out the window</p>
                        </div>
                    </div>
                    <div className="col col-lg-7 col-12">
                        <div className="events-slider-holder">
                            <div className="events-slider">
                                <Swiper
                                    modules={[Navigation, A11y]}
                                    spaceBetween={30}
                                    slidesPerView={3}
                                    navigation
                                    loop={true}
                                    speed={1000}
                                    autoplay={{
                                        delay: 3000,
                                        disableOnInteraction: false,
                                    }}
                                    breakpoints={{
                                        1400: {
                                            slidesPerView: 3,
                                        },
                                        1024: {
                                            slidesPerView: 2,
                                        },
                                        991: {
                                            slidesPerView: 2,
                                        },
                                        767: {
                                            slidesPerView: 1,
                                        },
                                        575: {
                                            slidesPerView: 1,
                                        },
                                        480: {
                                            slidesPerView: 1,
                                        },
                                    }}
                                >
                                    {Events.slice(0, 6).map((event, citem) => (
                                        <SwiperSlide key={citem}>
                                            <div className="events-slider-item">
                                                <div className="grid">
                                                    <div className="img-holder">
                                                        <img src={event.eImg} alt="" />
                                                    </div>
                                                    <div className="details">
                                                        <div className="inner">
                                                            <h3><Link onClick={ClickHandler} to={`/event-single/${event.slug}`}>{event.eTitle}</Link></h3>
                                                            <p>Aug 25, 2020 (10 AM)</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default EventsSection;